import $ from 'jquery';

$(function () {
  const resetAllNotifications = function () {
    $('.notification').removeClass('appear');
  };

  var activeNotificationTimeout;
  const setHideNotification = function () {
    return setTimeout(resetAllNotifications, 5 * 1000);
  };

  const showErrorsNotification = function (errorsList) {
    const errorsHtml = errorsList.map(function (error) {
      return '<div class="error">' + error + '</div>';
    });
    $('.js-error-list').html(errorsHtml);
    $('.notification.errors').addClass('appear');
    activeNotificationTimeout = setHideNotification();
  };

  const showLastSentNotification = function (data) {
    const $container = $('.notification.last-sent');
    $('input[name="id"]', $container).val(data.id);
    $('input[name="delayed_solicitation_request_employee_id"]', $container).val(
      data.employeeId,
    );
    $('.js-notification-logo img', $container).attr('attr', data.brandLogo);
    $('.js-brand-name', $container).text(data.brandName);
    $('.js-customer-name', $container).text(data.customerName);
    $('.js-customer-email', $container).text(data.customerEmail);
    $('.js-channel-name', $container).text(data.channelName);
    $container.addClass('appear');
    activeNotificationTimeout = setHideNotification();
  };

  $('#js-manual-request-form')
    .on('ajax:beforeSend', function () {
      $('.notification').removeClass('appear');
      $('.action-cancel').html('Cancel');
    })
    .on('ajax:success', function ({ originalEvent }) {
      const [data] = originalEvent.detail;
      $('.option-text-field input', event.target).val('');
      showLastSentNotification(data);
    })
    .on('ajax:error', function ({ originalEvent }) {
      const [data] = originalEvent.detail;
      const errors = data ? data.errors : ['Something went wrong...'];
      showErrorsNotification(errors);
    });

  $('#js-manual-request-cancel-form')
    .on('ajax:beforeSend', function () {
      clearTimeout(activeNotificationTimeout);
      $('.action-cancel').html('<i class="fa fa-loading"></i>&nbsp;Cancelling');
    })
    .on('ajax:success', function (_event) {
      $('.action-cancel').html('<i class="fa fa-check"></i>&nbsp;Cancelled');
      activeNotificationTimeout = setHideNotification();
    })
    .on('ajax:error', function () {
      showErrorsNotification(["Couldn't cancel request..."]);
      activeNotificationTimeout = setHideNotification();
    });

  $('.notification.errors .fa-times').on('click', resetAllNotifications);

  const setSubmitLabel = function (checkedBrandLabel) {
    $('.request-submit').html(
      'Send Request <span>from</span> ' + checkedBrandLabel,
    );
  };

  if ($('.request-option.branding').length) {
    $('.request-option.branding input[type="radio"]').on(
      'change',
      function (event) {
        setSubmitLabel(event.target.labels[0].innerHTML);
      },
    );

    const checkedBrandLabel = $(
      '.request-option.branding input:checked + label',
    ).text();
    setSubmitLabel(checkedBrandLabel);
  }
});
